import api from 'api';
import { REPORT_STATE } from 'api/reports/constants';
import { IReportsPath } from 'api/reports/types';
import Button from 'components/Button';
import { ActionsWrapper } from 'components/Downloads/styled';
import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import { ICONS_MAP } from 'constants/icons';
import { appReactMemo } from 'hocs';
import { useDeleteReport } from 'queries/reports';
import { StyledDangerButton } from 'routes/pages/AuthorizedStack/styled';
import { downloadFile } from 'utils/fileService';

import { TReportRowCellProps } from './types';

interface IActionsCellProps extends IReportsPath, TReportRowCellProps {}

const ActionsCell = ({ item, path, ...rest }: IActionsCellProps) => {
  const { mutate: deleteReport } = useDeleteReport();
  const { fileName, id, status } = item;

  const onDeleteReport = () => {
    deleteReport({ id, path });
  };

  const onDownloadReport = async () => {
    const reportLink = await api.reports.getReportFileLink({ id, path });

    if (reportLink) {
      downloadFile(fileName, reportLink);
    }
  };

  return (
    <RowCell {...rest} item={item}>
      <ActionsWrapper>
        {status === REPORT_STATE.COMPLETED && (
          <Button
            endIcon={<ICONS_MAP.Download />}
            iconSize={18}
            onClick={onDownloadReport}
            testIds={{ container: 'reportsModalDownloadButton' }}
            variant='icon'
          />
        )}
        <StyledDangerButton
          endIcon={<ICONS_MAP.Delete />}
          iconSize={18}
          onClick={onDeleteReport}
          testIds={{ container: 'reportsModalDeleteButton' }}
          variant='icon'
        />
      </ActionsWrapper>
    </RowCell>
  );
};

export default appReactMemo(ActionsCell);
